import ScoringService from '@/api/admin/scoring.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
      adTypes: {},
      selectedAdType: null,
    },
  },
  getters: {
    getMultipliers: state => state.table,
  },
  actions: {
    async getScoreMultipliers({ commit }, adTypeId) {
      const multipliers = await ScoringService.getScoreMultipliers(adTypeId || 1)
      commit('SET_MULTIPLIERS', multipliers)
    },
  },
  mutations: {
    SET_MULTIPLIERS(state, multipliers) {
      state.table.rows = multipliers.multipliers
      state.table.adTypes = multipliers.adTypes
      state.table.selectedAdType = multipliers.selectedAdType
    },
    SET_MULTIPLIERS_VALUE(state, multipliersValue) {
      state.table.rows[multipliersValue.index].value = multipliersValue.formattedRow.value
    },
  },
}
